import { get, post } from '../httpClient';

/**
 * Client for /api/stripe/creator/* — self-scoped subscription management
 * for the authenticated creator. Mirrors src/api/subscriptions.js but
 * keyed off the current user instead of an orgId.
 */
export const creatorSubscriptionsAPI = {
  /** Free -> Pro: returns { checkoutUrl } to redirect to Stripe. */
  createSubscriptionCheckout: (tier, interval = 'monthly') =>
    post(
      '/api/stripe/creator/create-subscription-checkout',
      JSON.stringify({ tier, interval })
    ),

  /** Paid -> paid (different tier or interval) with proration. */
  changeSubscriptionTier: (targetTier, interval = 'monthly') =>
    post(
      '/api/stripe/creator/change-subscription-tier',
      JSON.stringify({ targetTier, interval })
    ),

  /** Cancel — `immediate=true` ends right away; default is at period end. */
  cancelSubscription: (immediate = false) =>
    post('/api/stripe/creator/cancel-subscription', JSON.stringify({ immediate })),

  /** Un-cancel a subscription scheduled to cancel at period end. */
  resumeSubscription: () =>
    post('/api/stripe/creator/resume-subscription', JSON.stringify({})),

  /** Stripe-hosted billing portal session for invoices/cards/etc. */
  createCustomerPortalSession: returnPath =>
    post(
      '/api/stripe/creator/create-customer-portal',
      JSON.stringify({ returnPath })
    ),

  /**
   * Recent balance transactions on the creator's Stripe Connect account —
   * what's landed in their balance from memberships / live rooms /
   * donations. Returns { items, hasMore, nextCursor }.
   */
  getPayoutHistory: ({ limit = 25, startingAfter } = {}) =>
    get('/api/stripe/creator/payout-history', {
      limit,
      ...(startingAfter ? { starting_after: startingAfter } : {}),
    }),
};
